// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AccordionController from "./accordion_controller"
application.register("accordion", AccordionController)

import AcompanhamentoController from "./acompanhamento_controller"
application.register("acompanhamento", AcompanhamentoController)

import AniversarioController from "./aniversario_controller"
application.register("aniversario", AniversarioController)

import AtendimentoChamarController from "./atendimento_chamar_controller"
application.register("atendimento-chamar", AtendimentoChamarController)

import AutoPagoController from "./auto_pago_controller"
application.register("auto-pago", AutoPagoController)

import AutoReloadController from "./auto_reload_controller"
application.register("auto-reload", AutoReloadController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import CepController from "./cep_controller"
application.register("cep", CepController)

import CheckAllController from "./check_all_controller"
application.register("check-all", CheckAllController)

import CidadeFilterController from "./cidade_filter_controller"
application.register("cidade-filter", CidadeFilterController)

import CkeditorController from "./ckeditor_controller"
application.register("ckeditor", CkeditorController)

import ClienteFonteController from "./cliente_fonte_controller"
application.register("cliente-fonte", ClienteFonteController)

import DocUploadController from "./doc_upload_controller"
application.register("doc-upload", DocUploadController)

import FormSubmitController from "./form_submit_controller"
application.register("form-submit", FormSubmitController)

import MaskController from "./mask_controller"
application.register("mask", MaskController)

import MultiselectComboboxController from "./multiselect_combobox_controller"
application.register("multiselect-combobox", MultiselectComboboxController)

import NotificacaoTipoController from "./notificacao_tipo_controller"
application.register("notificacao-tipo", NotificacaoTipoController)

import PagamentoFormController from "./pagamento_form_controller"
application.register("pagamento-form", PagamentoFormController)

import ProcessoFormController from "./processo_form_controller"
application.register("processo-form", ProcessoFormController)

import RemoteFilterController from "./remote_filter_controller"
application.register("remote-filter", RemoteFilterController)

import TogglerController from "./toggler_controller"
application.register("toggler", TogglerController)

import DocumentoCamposController from "./documento_campos_controller"
application.register("documento-campos", DocumentoCamposController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import TomSelectController from "./tom_select_controller"
application.register("tom-select", TomSelectController)

import Ui__CascadeController from "./ui/cascade_controller"
application.register("ui--cascade", Ui__CascadeController)

import Ui__ComboboxController from "./ui/combobox_controller"
application.register("ui--combobox", Ui__ComboboxController)

import Ui__DisclosureController from "./ui/disclosure_controller"
application.register("ui--disclosure", Ui__DisclosureController)

import Ui__DismissController from "./ui/dismiss_controller"
application.register("ui--dismiss", Ui__DismissController)

import Ui__DropdownController from "./ui/dropdown_controller"
application.register("ui--dropdown", Ui__DropdownController)

import Ui__ModalController from "./ui/modal_controller"
application.register("ui--modal", Ui__ModalController)

import Ui__RemoteToggleController from "./ui/remote_toggle_controller"
application.register("ui--remote-toggle", Ui__RemoteToggleController)

import Ui__TabsController from "./ui/tabs_controller"
application.register("ui--tabs", Ui__TabsController)

import Ui__TabsNavController from "./ui/tabs_nav_controller"
application.register("ui--tabs-nav", Ui__TabsNavController)

import Ui__TooltipController from "./ui/tooltip_controller"
application.register("ui--tooltip", Ui__TooltipController)

import Ui__TurboModalController from "./ui/turbo_modal_controller"
application.register("ui--turbo-modal", Ui__TurboModalController)
